/// <amd-module name="Dashboards/DashboardView/src/redux/sagas/SagaContext" />
import { IVssPageContext } from "VSS/Platform/Context";

export namespace IDashboardViewContext {
    /** The property in the saga context containing the view context */
    export const prop = "dashboardViewContext";
}

/** Contextual information made available through effects.getContext */
export interface IDashboardViewContext {}

type WrappedContext<T extends { [k: string]: any }, P> = { [k in T[Extract<keyof T, string>]]: P };
type WrappedDashboardViewContext = WrappedContext<typeof IDashboardViewContext, IDashboardViewContext>;
type WrappedPageContext = { pageContext: IVssPageContext };

export type DashboardViewSagaContext = WrappedDashboardViewContext & WrappedPageContext;
